import React, { Fragment, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import AddCreditCardDialog from 'components/dialog/AddCreditCardDialog'

import { formatNumber, formatDate } from 'libraries/utils'

const PaymentTable = props => {
	const { t } = useTranslation();
	const [openDialog, setOpenDialog] = useState(false)
	const { data } = props

	const onRepay = () => {
		props.orderCreditCardPayment(props.orderId)
	}
	
	const handleOpenDialog= () => {
		setOpenDialog(!openDialog)
	}
	
	return (
		<Fragment>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell style={{paddingLeft: '30px'}}>{t('debit_date')}</TableCell>
						<TableCell>{t('payment_method')}</TableCell>
						<TableCell>{t('payment_total')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{data.get('orderTxnList').map((item, idx) => {
						const isLastItem = (idx + 1) === data.get('orderTxnList').size
						const isSuccess = item.get('isSuccess')
						return (
							<TableRow key={idx}>
								<TableCell style={{paddingLeft: '30px'}}>
									{formatDate(item.get('createdAt'))}
								</TableCell>
								<TableCell>
									<Grid container>
										<Typography style={{paddingRight:'5px'}}>
											{t('credit_card_last_four')}{item.get('creditCardLastFour')} 
										</Typography>
										{isSuccess ? 
											<Typography>
												- {t('debit_Succ')}
											</Typography>
											:
											<Typography color="error">
												- {t('debit_fail')}
											</Typography>
										}
										{!isSuccess && isLastItem
											&& (
												<Fragment>
													<Typography color="error">，</Typography>
													<Typography color="error" className="pointer"
														style={{textDecoration: 'underline'}}
														onClick={onRepay}
													>
														點擊重新付款
													</Typography>
													<Typography>或</Typography>
													<Typography color="error" className="pointer"
														style={{textDecoration: 'underline'}}
														onClick={handleOpenDialog}
													>
														更新信用卡資料並重新付款
													</Typography>
												</Fragment>
											)
										}
									</Grid>
								</TableCell>
								<TableCell>
									${formatNumber(item.get('amount'))}
								</TableCell>
							</TableRow>	
						)
					})}
				</TableBody>
			</Table>
			<AddCreditCardDialog
				open={openDialog}
				onClose={handleOpenDialog}
			/>
		</Fragment>
	)
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = {
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PaymentTable)
